const states = {
  step: 1,
  phone: '',
  pinCode: '',
};

export type StateType = typeof states;
export default states;
